import {
  BadgeCard,
  IconApple,
  IconWindows,
  Spacing,
} from '@kezios/design-system';
import { Flex, Text } from '@mantine/core';

import css from './CompatibilityBadge.module.css';

export type CompatibilityBadgeProps = {
  compatibilities: React.ReactNode[];
};

export const CompatibilityBadge = ({
  compatibilities,
}: CompatibilityBadgeProps) => {
  return (
    <BadgeCard px={Spacing.s10} py={Spacing.s3} className={css.badge}>
      <Flex gap={Spacing.s2} align={'center'}>
        <Flex direction="column" gap={Spacing.s1}>
          {compatibilities}
        </Flex>
        <Text className={css.text} variant="textMd.medium" c={'gray.9'}>
          -
        </Text>
        <IconApple
          size={39}
          style={{
            color: '#000',
          }}
          color="black"
        />
        <IconWindows
          size={39}
          color="#00a4ef"
          style={{
            color: '#00a4ef',
          }}
        />
      </Flex>
    </BadgeCard>
  );
};
